var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 18,
    viewBox: "0 0 13 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.667 13.781h7.666V6.234H2.667zm.666-2.297H5v1.641H3.333zm4-2.296v1.64H5.667v-1.64zM5.667 8.53v-1.64h1.666v1.64zM8 9.187h1.667v1.641H8zm-.667 2.297v1.641H5.667v-1.64zM5 10.828H3.333v-1.64H5zm3 2.297v-1.64h1.667v1.64zm1.667-4.594H8v-1.64h1.667zM5 6.891v1.64H3.333v-1.64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2 0H0v17.063h13V3.15zm2.133 16.406H.667V.656h9V3.61h2.666z"
  }))));
};
export default SvgList;